import { useQuery } from 'react-query';
import { getIsUserOnline } from '../services';

const BASE_KEY = 'is-user-online';
const MIN = 1000 * 60;

/**
 * @param {string} username
 * @returns {import('react-query').UseQueryResult<{isOnline: boolean;}>}
 */
export const useIsUserOnlineQuery = (username) => {
    const data = useQuery([BASE_KEY, username], () => getIsUserOnline(username), {
        cacheTime: 0,
        refetchInterval: 3 * MIN,
    });
    return data;
};
